import React from 'react';
import styled from 'styled-components';
import { Tooltip, Dropdown, Button, Space, MenuProps } from 'antd';
import { InfoCircleOutlined, DownOutlined } from '@ant-design/icons';

// Styled Components
const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 16px; /* Adjust based on your theme */
    gap: 8px; /* Replacement for f-gap-2 */

    .f-widget-title {
        flex: 1;
        font-weight: 600;
        font-size: 16px;
    }
`;

interface ChartHeaderProps {
    title: string;
    showInfoTooltip?: boolean;
    infoTooltip?: string;
    showTimeDropdown?: boolean;
    selectedTimeRange?: string;
    onMenuAction?: (key: 'edit' | 'setDefault' | 'delete') => void;
}

export const ChartHeader: React.FC<ChartHeaderProps> = ({
    title,
    showInfoTooltip = false,
    infoTooltip = 'This is a tooltip',
    showTimeDropdown = true,
    selectedTimeRange = 'Last 3 Hours',
    onMenuAction,
}: ChartHeaderProps) => {
    // Antd Menu items configuration
    const items: MenuProps['items'] = [
        { key: 'edit', label: 'Edit' },
        { key: 'setDefault', label: 'Set as Default' },
        { key: 'delete', label: 'Delete', danger: true },
    ];

    const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
        if (onMenuAction) {
            onMenuAction(key as 'edit' | 'setDefault' | 'delete');
        }
    };

    return (
        <HeaderContainer className="c-chart-header">
            {/* Title Section */}
            <div className="f-widget-title">{title}</div>

            {/* Info Tooltip Section */}
            {showInfoTooltip && (
                <Tooltip title={infoTooltip} placement="bottom">
                    <InfoCircleOutlined style={{ cursor: 'help', color: 'rgba(0,0,0,0.45)' }} />
                </Tooltip>
            )}

            {/* Time Dropdown Section */}
            {showTimeDropdown && (
                <Dropdown
                    menu={{ items, onClick: handleMenuClick }}
                    trigger={['click']}
                    overlayClassName="f-list-dropdown"
                >
                    <Button size="small" className="f-btn-sec">
                        <Space>
                            {selectedTimeRange}
                            <DownOutlined style={{ fontSize: '10px' }} />
                        </Space>
                    </Button>
                </Dropdown>
            )}
        </HeaderContainer>
    );
};

export default ChartHeader;
